module.exports = __webpack_public_path__ + "img/package_exp.d9658307.png";